import type { SessionUser } from '@/types'

import { useEffect, useState } from 'react'
import { api } from '@/lib/client/api'

type SessionState = {
    user: SessionUser | null
    ready: boolean
}

// Reads the signed-in person after the page mounts, so static pages stay static.
export const useSession = (initial: SessionUser | null = null): SessionState => {
    const [state, setState] = useState<SessionState>({ user: initial, ready: Boolean(initial) })

    useEffect(() => {
        if (initial) return

        let active = true

        api<{ user: SessionUser | null }>('/api/auth/me')
            .then(data => {
                if (active) setState({ user: data.user, ready: true })
            })
            .catch(() => {
                if (active) setState({ user: null, ready: true })
            })

        return () => {
            active = false
        }
    }, [initial])

    return state
}
